module.exports = __webpack_public_path__ + "img/ico-time.f45672b6.svg";